import { render, staticRenderFns } from "./ElderlyOrderMonth.vue?vue&type=template&id=48118725&scoped=true&"
import script from "./ElderlyOrderMonth.vue?vue&type=script&lang=js&"
export * from "./ElderlyOrderMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48118725",
  null
  
)

export default component.exports